import { render, staticRenderFns } from "./MyMoveToArchive.vue?vue&type=template&id=00260ca8&scoped=true"
import script from "./MyMoveToArchive.vue?vue&type=script&lang=js"
export * from "./MyMoveToArchive.vue?vue&type=script&lang=js"
import style0 from "./MyMoveToArchive.vue?vue&type=style&index=0&id=00260ca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00260ca8",
  null
  
)

export default component.exports